<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "ImportBankTallyLog"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ImportBankTallyLog.vue